import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { Col } from 'react-bootstrap'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { actualizarHistogramas } from '../../actions/HistogramaActions'
import HistogramaVolcadoras from './HistogramaVolcadoras'
import HistogramaIngreso from './HistogramaIngreso'
import HistogramaCaladoPorPuesto from './HistogramaCaladoPorPuesto'
import HistogramaBalanzas from './HistogramaBalanzas'
import HistogramaIngresoPorUsuario from './HistogramaIngresoPorUsuario'

function Histogramas (props) {
  const { actualizarHistogramas } = props

  useEffect(() => {
    actualizarHistogramas(new Date(), new Date())
  }, [actualizarHistogramas])

  const actualizarfechas = (fechaD, fechaH) => {
    actualizarHistogramas(fechaD, fechaH)
  }

  return (
    <>
      <h2>Histogramas</h2>

      <Col md={4} style={{ margin: '12px auto' }}>
        <DatePicker
          style={{ width: '95%' }}
          disabledFuture
          selectRange
          locale='es'
          onDateChange={actualizarfechas}
          titulo='Seleccione las fechas'
        />
      </Col>

      <HistogramaIngreso />
      <HistogramaIngresoPorUsuario />
      <HistogramaCaladoPorPuesto />
      <HistogramaBalanzas />
      <HistogramaVolcadoras showCalendar={false} />

    </>
  )
}

const mapActionsToProps = {
  actualizarHistogramas
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(Histogramas)
